import { Component, computed, effect, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiAgencyFormComponent } from '../../../../../shared/ui-agency-form/src/lib/ui-agency-form/ui-agency-form.component';
import { AgencySaveREQ, AgencyStore, LookupStore } from '@program-suite/data-common';
import { AgencyFormModel } from '@program-suite/ui-agency-form';
import { ButtonComponent } from '@program-suite/ui';
import { FormDropdownComponent } from '@program-suite/ui';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'lib-agency',
  imports: [CommonModule, UiAgencyFormComponent, ButtonComponent, FormDropdownComponent, ReactiveFormsModule],
  templateUrl: './agency.component.html',
  styleUrl: './agency.component.scss',
})
export class AgencyComponent implements OnInit {
  lookupStore = inject(LookupStore);
  agencyStore = inject(AgencyStore);
  agencyDetails = computed(() => this.agencyStore.agencyDetails() ?? null);
  agencyFormValues = computed(() => {
    const agency = this.agencyDetails();
    if (agency) {
      const programIds = agency.programs?.filter((p) => p.checked).map((p) => p.programId) ?? [];

      return {
        id: agency.id,
        agencyName: agency.agencyName,
        licenseNumber: agency.licenseNumber,
        streetAddress: agency.streetAddress,
        suite: agency.suite,
        city: agency.city,
        state: agency.state,
        zipCode: agency.zipCode,
        phone: agency.phone,
        websiteUrl: agency.websiteUrl,
        programIds: programIds,
        status: agency.isActive ? 'Active' : 'Inactive',
      } as AgencyFormModel;
    }
    return null;
  });

  form!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      agency: [null, Validators.required],
      status: [''],
    });

    effect(() => {
      const statuses = this.lookupStore.agencyUserStatus() ?? [];
      if (statuses) {
        this.form.get('status')?.patchValue(this.agencyFormValues()?.status ?? '');
      }
    });

    effect(() => {
      const agencyFormValues = this.agencyFormValues();
      if (agencyFormValues) {
        this.form.patchValue({ agency: agencyFormValues });
      }
    });
  }

  ngOnInit(): void {
    this.lookupStore.loadLookup('programs');
    this.lookupStore.loadLookup('states');
    this.lookupStore.loadLookup('agencyUserStatus');
  }

  onSubmit() {
    const data = this.form.get('agency')?.value;
    const agency: AgencySaveREQ = {
      agencyName: data.agencyName,
      streetAddress: data.streetAddress,
      suite: data.suite,
      licenseNumber: data.licenseNumber,
      websiteUrl: data.websiteUrl,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
      phone: data.phone,
      programIds: data.programIds,
      id: data.id,
    };

    const status = this.form.get('status')?.value;
    agency.isActive = status === 'Active' ? true : false;
    this.agencyStore.upsertAgency(agency);
  }
}
